import { baseApi } from "./baseApi";

export const tradingApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPositions: builder.query({
      query: () => "/trading/positions",
      providesTags: ["Positions"],
    }),
    getOrderHistory: builder.query({
      query: () => "/trading/orders/history",
      providesTags: ["Orders"],
    }),
    getOpenOrders: builder.query({
      query: ({ status = "open", limit = 100 } = {}) => `/trading/orders?status=${status}&limit=${limit}`,
      providesTags: ["Orders"],
    }),
    placeBuyOrder: builder.mutation({
      query: (body) => ({
        url: "/trading/orders/buy",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Orders", "Positions"],
    }),
    placeSellOrder: builder.mutation({
      query: (body) => ({
        url: "/trading/orders/sell",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Orders", "Positions"],
    }),
    cancelOrder: builder.mutation({
      query: (orderId) => ({
        url: `/trading/orders/${orderId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Orders"],
    }),
    replaceOrder: builder.mutation({
      query: ({ orderId, body }) => ({
        url: `/trading/orders/${orderId}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: ["Orders"],
    }),
  }),
  overrideExisting: false,
});
